module.exports = __webpack_public_path__ + "media/images/colorpicker/hue-9bb11283dedf8031a25e1e6d19f58a60.png";